import { APIClient } from "../../helpers/api_helper";
const AxiosClient = new APIClient();
const AllPriorityList = (params) => AxiosClient.get("/priority", params);
export { AllPriorityList };
